export const schools = [
    {
        'name': '造型艺术学院',
        'id': '0',
        'desc': `2019年，学校开展学院制改革，实施强强融合战略，整合油画系、版画系、雕塑系三个院系组建为造型艺术学院。造型艺术学院秉持开放包容、与时俱进的办学传统；坚持面向未来，积极服务社会发展需求；坚持以学为中心，提升学生学习体验与学习成效；坚持协同育人，注重产教融合与开放办学；倡导多元培养模式的探索，致力培养适应社会发展需求的多类型的艺术专门人才。`,
        'tag': 'zxys',
        'color': '#10ABFF',
        'path': 'detail?id=9&title=造型艺术学院',
        'logo': require('../assets/show/head/0.png'),
    },
    {
        'name': '设计学院',
        'id': '1',
        'desc': `四川美术学院在1940年由李有行、沈福文、庞熏琹、雷圭元等设计先师建校，“开创中国设计分科教育先河。”
        设计学院拥有国家五一劳动奖章国家获得者、国家百千万人才工程、国家突出贡献中青年专家、全国美展金奖获得者等。设计学院经略西部，深耕绿色发展；携同城乡，构建研创高地；融通研学，精绘育人样本。`,
        'tag': 'sjxy',
        'color': '#02DB00',
        'path': 'detail?id=4&title=设计学院',
        'logo': require('../assets/show/head/1.png'),
    },
    {
        'name': '建筑与环境艺术学院',
        'id': '2',
        'desc': `建筑与环境艺术学院依托四川美院丰厚的艺术与人文底蕴，坚持探索艺术院校建环教育之办学特色，打造以人文艺术为优势、科学技术为支撑的特色教育，形成了国际化背景下具有艺术特色、地域特色的建环教育思想，以培养空间艺术视野下的建筑、环艺及风景园林设计创作人才，进而满足新形势下的行业发展需求。建筑与环境艺术学院下设建筑系、风景园林系和环境设计系。`,
        'tag': 'jzyhj',
        'color': '#00DC02',
        'path': 'detail?id=3&title=建筑与环境艺术学院',
        'logo': require('../assets/show/head/2.png'),
    },
    {
        'name': '实验艺术学院',
        'id': '3',
        'desc': `实验艺术学院下设实验艺术系与摄影艺术系，有实验艺术与摄影艺术两个本科专业，艺术与社会、艺术与科技、跨媒体艺术、动态影像与图片摄影等五个专业方向。
        实验艺术学院先后获得4个国家级项目，15个省级项目，20个横向项目；获得重庆市社会科学优秀成果奖1项，重庆市教改项目22个。学院先后获得重庆市创新创业示范团队，省级特色专业，省级—流专业等称号，并承担了重庆市新媒介美术创作重点实验室的组织运行。`,
        'tag': 'syys',
        'color': '#FF49EF',
        'path': 'detail?id=5&title=实验艺术学院',
        'logo': require('../assets/show/head/3.png'),
    },
    {
        'name': '公共艺术学院',
        'id': '4',
        'desc': '公共艺术学院立足重庆、服务西南、面向全国，聚焦中国城市化进程，服务新时代城市更新和文化复兴，致力于人才培养，努力建设成为在城市艺术设计领域，学科专业一体化协同发展，具有鲜明特色和区域影响力的艺术设计学院。坚持 “以本为本”，深耕城市美学研究、聚焦城市艺术设计，以教育教学、科研创作为核心，以“产学研”服务经济社会发展，培养高素质、创新性、应用型专门艺术设计人才。学院设有公共艺术和艺术与科技2个专业。',
        'tag': 'ggys',
        'color': '#FF8103',
        'path': 'detail?id=2&title=公共艺术学院',
        'logo': require('../assets/show/head/4.png'),
    },
    {
        'name': '影视动画学院',
        'id': '5',
        'desc': `1996年四川美术学院于全国八大美术院校中首先筹备开设动画专业，1999年正式设置四年制本科动画专业并成立影视艺术系（现影视动画学院）。2005年影视动画学院实施开门办学，2007年获批 “教育部第一批高等学校特色专业建设点”“教育部人才培养模式创新实验区”，通过实验教学形成了 “出人才、出原创”的特色，实现研发、创作动画片856集（原创9000分钟）的规模化输出和转化，服务于行业，特别是重庆文化创意品牌打造和发展。`,
        'tag': 'ysdh',
        'color': '#FF49EF',
        'path': 'detail?id=8&title=影视动画学院',
        'logo': require('../assets/show/head/5.png'),
    },
    {
        'name': '中国画与书法艺术学院',
        'id': '6',
        'desc': `中国画与书法艺术学院前身是四川美术学院中国画系，学院秉承四川美术学院80年来中国画与书法教学创作的优良传统，在新的历史时期致力于传承和弘扬中国优秀传统艺术。
        中国画与书法艺术学院是国家学科评估A级方阵的美术学一级学科核心建设单位。1981年成为全国首批获硕士学位授予权的学科点，2007年被评为“国家级特色专业”，2009年被评为重庆市优秀教学团队，2019年中国画专业被评为国家一流专业。学院曾经多次获得省部级教学成果一等奖，享有良好的社会声誉。`,
        'tag': 'zghysfys',
        'color': '#10AAFF',
        'path': 'detail?id=10&title=中国画与书法艺术学院',
        'logo': require('../assets/show/head/6.png'),
    },
    {
        'name': '艺术教育学院',
        'id': '7',
        'desc': `艺术教育学院源起于 1981 年成立的师范系，是全国专业艺术院校中第一批设立的师范系科，经过近 40年的发展，已经形成了由 30 人组成的结构合理、经验丰富的高素质创新教学团队。2019年7月，正式成立艺术教育学院。学院下设美术教育系、设计教育系、水彩画系、综合艺术系。`,
        'tag': 'ysjy',
        'color': '#FF8103',
        'path': 'detail?id=6&title=艺术教育学院',
        'logo': require('../assets/show/head/7.png'),
    },
    {
        'name': '艺术人文学院',
        'id': '8',
        'desc': `艺术人文学院的前身美术学系成立于1996年，2019年7月正式更名为艺术人文学院。1998 年开始招收本科生，1999年开始招硕士研究生，是川美唯一理论院系。经过近30年的发展，学院已经拥有了一支富有专业素养、充满活力、爱岗敬业的师资队伍；培养了一群活跃于当下艺术现场的优秀华业生；培育了一批具有中国特色的理论成果。`,
        'tag': 'ysrw',
        'color': '#FF49EF',
        'path': 'detail?id=7&title=艺术人文学院',
        'logo': require('../assets/show/head/8.png'),
    },
    {
        'name': '个性化培养特色工作室',
        'id': '9',
        'desc': `艺术教育非常重要的一个特点就是注重学生的个性培养。四川美术学院一直致力于高等艺术教育大众化背景下艺术英才个性化培养探索，自2015年开始实施“个性化培养特色工作室计划”。学校聘请或遴选有自己个性研究的、经验丰富的、热心教育的导师，以其个人在某个领域的专长为基础组建了个性化培养特色工作室，在学生选拔、教学活动、教学管理、经费运行等方面通过政策支持给子充分保障和自由。`,
        'tag': 'gxhpy',
        'color': '#10AAFF',
        'path': 'detail?id=1&title=个性化培养特色工作室',
        'logo': require('../assets/show/head/9.png'),
    },
];
